import React from "react";
import { Link, Redirect } from 'react-router-dom';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import IconButton from "@material-ui/core/IconButton";
import Avatar from '@material-ui/core/Avatar';
import Snackbar from '@material-ui/core/Snackbar';
import CloseIcon from '@material-ui/icons/Close';
import firebase, { auth, db, storage } from "../../settings/firebase";
import getQueryStrings from '../../utils/getQueryStrings';
import { GoogleIcon, TwitterIcon, FacebookIcon, TiktokIcon, YoutubeIcon, NoteIcon } from '../../components/SVG/SnsIcon';
import InstagramIcon from '../../img/instagram.png';
import SettingSns from "../../components/SettingSns";
import './Settings.css';
import Divider from "@material-ui/core/Divider";

// 保存ボタン
function SaveBtn(props) {
  const { handleSave, enable } = props;
  return (
    <Button
      type="button"
      onClick={handleSave}
      disabled={!enable}
      fullWidth
      variant="contained"
      color="primary"
      className={"saveSettingsBtn"}
    >
      保存
    </Button>
  )
}

// 設定画面
export default class Settings extends React.Component {
  constructor(props) {
    super(props);
    const query = window.location.search;
    let redirect = "/";
    let skippable = false;
    let intro = false;
    if (query) {
      const queries = getQueryStrings(query);
      if (queries["redirect"] !== undefined) redirect = queries["redirect"];
      if (queries["skippable"] === "true") skippable = true;
      if (queries["intro"] === "1") intro = true;
    }
    this.state = {
      redirect: decodeURIComponent(redirect),
      isSkippable: skippable,
      intro: intro,
      nowname: "",
      name: "",
      nowavatarUrl: "",
      avatarUrl: "",
      avatarBase64: "",
      avatarImgType: "",
      nowdisplayId: "",
      displayId: "",
      nowprofiletext: "",
      profiletext: "",
      ngDisplayId: false,
      isChangedName: 2,
      isChangedAvatar: 2,
      isChangedDid: 2,
      isChangedProftext: 2,
      twitter: null, //Twitter連携
      google: null, //Google連携
      facebook: null, //Facebook連携
      instagram: {url: "", nowurl: ""}, //Instagram連携
      note: {url: "", nowurl: ""}, //note連携
      youtube: {url: "", nowurl: ""}, //YouTube連携
      tiktok: {url: "", nowurl: ""}, //TikTok連携
      nowmail: "",
      mail: "",
      mailverified: false,
      isChangedMail: 2,
      open: false,
      snackmessage: "",
    };
    this.componentDidMount = this.componentDidMount.bind(this);
    this.componentWillUnmount = this.componentWillUnmount.bind(this);
    this.changeName = this.changeName.bind(this);
    this.changeAvatarUrl = this.changeAvatarUrl.bind(this);
    this.changeDisplayId = this.changeDisplayId.bind(this);
    this.changeProfiletext = this.changeProfiletext.bind(this);
    this.updateProfile = this.updateProfile.bind(this);
    this.sendEmailVerification = this.sendEmailVerification.bind(this);
    this.sendPassSetting = this.sendPassSetting.bind(this);
    this.alertClose = this.alertClose.bind(this);
    this.changeMail = this.changeMail.bind(this);
  }

  _isMounted = false;

  // 現在の設定を読み込む
  async componentDidMount() {
    const user = auth.currentUser;
    if (user !== null) {
      this.setState({
        nowname: user.displayName, name: user.displayName,
        nowavatarUrl: user.photoURL, avatarUrl: user.photoURL,
      });
      let providerProf = {};
      user.providerData.forEach((profile) => {
        if (profile.providerId === "twitter.com") {
          providerProf["twitter"] = {uid: profile.uid, name: profile.displayName, photo: profile.photoURL};
        } else if (profile.providerId === "google.com") {
          providerProf["google"] = {uid: profile.uid, name: profile.displayName, photo: profile.photoURL, mail: profile.email};
        } else if (profile.providerId === "facebook.com") {
          providerProf["facebook"] = {uid: profile.uid, name: profile.displayName, photo: profile.photoURL};
        }
      });
      // console.log(providerProf)
      await new Promise(resolve => setTimeout(resolve, 500));
      db.collection("users").doc(user.uid).get().then((doc) => {
        if (doc.exists) {
          const instagram = {url: doc.data().instagram, nowurl: doc.data().instagram};
          const tiktok = {url: doc.data().tiktok, nowurl: doc.data().tiktok};
          const youtube = {url: doc.data().youtube, nowurl: doc.data().youtube};
          const note = {url: doc.data().note, nowurl: doc.data().note};
          this.setState({
            nowdisplayId: doc.data().displayid, displayId: doc.data().displayid,
            nowprofiletext: doc.data().intro, profiletext: doc.data().intro, nowmail: user.email,
            mail: user.email, mailverified: user.emailVerified,
            twitter: providerProf.twitter, google: providerProf.google, facebook: providerProf.facebook,
            instagram: instagram, note: note, tiktok: tiktok, youtube: youtube
          })
        }
      })
    }
    this._isMounted = true;
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  changeName(e) {
    let changed = 1;
    if (e.target.value === "") {
      changed = 0;
    } else if (e.target.value === this.state.nowname) {
      changed = 2;
    }
    this.setState({name: e.target.value, isChangedName: changed});
  }

  // アバターアイコン画像をアップロードしたとき
  changeAvatarUrl(e) {
    console.log(e.target.files)
    let photoUrl = this.state.nowavatarUrl;
    let changed = 1;
    let type = "";
    if (e.target.files.length === 0) {
      changed = 2;
    } else if (e.target.files[0].size < 1048576 || ["image/png", "image/jpeg"].indexOf(e.target.files[0].type)) {
      const imageFile = e.target.files[0];
      photoUrl = URL.createObjectURL(imageFile);
      type = imageFile.type;
      const reader = new FileReader();
      const avatarthis = this;
      reader.addEventListener("load", function () {
        // 画像ファイルを base64 文字列に変換
        avatarthis.setState({avatarBase64: reader.result})
      }, false);
      reader.readAsDataURL(imageFile)
    } else {
      changed = 0;
      this.popupinfo("ファイルサイズが1MBを超えています")
    }
    this.setState({avatarUrl: photoUrl, avatarImgType: type, isChangedAvatar: changed});
  }

  async changeDisplayId(e) {
    this.setState({displayId: e.target.value});
    let changed = 1;
    let ngDisplayid = false;
    if (e.target.value.length < 3) {
      changed = 0;
    } else if (e.target.value === this.state.nowdisplayId) {
      changed = 2;
    } else {
      await db.collection("displayids").doc(e.target.value).get()
      .then((doc) => {
        if (doc.exists) {
          changed = 0;
          ngDisplayid = true;
        }
      })
    }
    this.setState({isChangedDid: changed, ngDisplayId: ngDisplayid});
  }

  changeProfiletext(e) {
    let profiletext = e.target.value;
    // console.log(this.state.nowprofiletext)
    let isChangedProftext = 1
    if (profiletext === this.state.nowprofiletext) {
      isChangedProftext = 2;
    }
    this.setState({profiletext: profiletext, isChangedProftext: isChangedProftext});
  }

  changeMail(e) {
    let mail = e.target.value;
    let isChangedMail = 0;
    const reg = /^[A-Za-z0-9]{1}[A-Za-z0-9_.-]*@{1}[A-Za-z0-9_.-]{1,}.[A-Za-z0-9]{2,}$/;
    if (mail === this.state.nowmail) {
      isChangedMail = 2;
    } else if (reg.test(mail)) {
      isChangedMail = 1;
    }
    this.setState({mail: mail, isChangedMail: isChangedMail})
  }

  async updateProfile() {
    const user = firebase.auth().currentUser;
    const userDocRef = db.collection("users").doc(user.uid);

    let profData = {};
    // 表示名の更新
    if(this.state.name !== "" && this.state.name !== this.state.nowname) {
      profData.displayName = this.state.name;
      await userDocRef.update({name: this.state.name});
    }
    // アバター画像の更新
    if(this.state.avatarUrl !== "" && this.state.avatarUrl !== this.state.nowavatarUrl) {
      let filepath = "profile/" + user.uid;
      if (this.state.avatarImgType === "image/png") {
        filepath += ".png";
      } else if (this.state.avatarImgType === "image/jpeg") {
        filepath += ".jpg";
      }
      const storageRef = storage.ref().child(filepath);
      await storageRef.delete().then(async function() {
        console.log("現在のプロフィール画像を削除しました");
      }).catch(function(error) {
        console.log(error, "現在のプロフィール画像を削除できませんでした");
      });
      // BASE64ファイルをアップロード
      const imgString = this.state.avatarBase64;
      await storageRef.putString(imgString, "data_url")
      .then(async function(snapshot) {
        console.log('Uploaded a blob or file!');
        await storageRef.getDownloadURL().then(async function (url) {
          profData.photoURL = url;
          await userDocRef.update({avatarUrl: url});
        })
      }).catch(function(error) {
        console.log(error, "ファイルをアップできませんでした");
      });
    }
    // マイページIDの更新
    if(this.state.isChangedDid === 1) {
      const docRef = db.collection("displayids").doc(this.state.displayId);
      await db.runTransaction((transaction) => {
        return transaction.get(docRef).then(async(sfDoc) => {
          if (sfDoc.exists) {
            throw "このIDはすでに使用されています";
          }
          await transaction.get(userDocRef).then(async (userDoc) => {
            if (!userDoc.exists) {
              throw "ユーザIDが見つかりません";
            }
            const delDocRef = db.collection("displayids").doc(userDoc.data().displayid);
            await transaction.set(docRef, { uid: user.uid });
            await transaction.update(userDocRef, { displayid: this.state.displayId });
            await transaction.delete(delDocRef);
          })
        });
      });
    }

    // 自己紹介を更新する
    if(this.state.isChangedProftext === 1) {
      userDocRef.update({intro: this.state.profiletext});
    }

    // メールアドレスを更新する
    if(this.state.isChangedMail === 1) {
      user.updateEmail(this.state.mail).then(() => {
        console.log("メールアドレスが更新されました。");
        firebase.auth().currentUser.sendEmailVerification().then(() => {
          console.log("確認メールを送信しました。");
          this.setState({nowmail: this.state.mail, isChangedMail: 2})
        });
      }).catch((error) => {
        console.log("メールアドレスの更新に失敗しました。", error);
        this.setState({mail: this.state.nowmail, isChangedMail: 2});
      });
    }

    user.updateProfile(profData).then(() => {
      console.log("プロフィールを更新しました");
      this.setState({isChanged: false, isChangedName: 2, isChangedAvatar: 2, isChangedDid: 2, isChangedProftext: 2, open: true, snackmessage: "プロフィールを更新しました。"});
      if (this.state.intro) {
        window.location.href = "/?intro=1";
      }
    }).catch((error) => {
      console.log(error);
      this.popupinfo("問題が発生しました。もう一度お試しください。");
    }); 
  }

  sendEmailVerification() {
    if (this.state.nowmail !== "") {
      auth.currentUser.sendEmailVerification().then(() => {
        console.log("確認メールを送信しました。")
        this.popupinfo("確認メールを送信しました。メールを確認してメール確認を完了してください。")
      });
    }
  }
  sendPassSetting() {
    if (this.state.nowmail !== "") {
      auth.sendPasswordResetEmail(this.state.nowmail).then(() => {
        console.log("パスワード再設定メールを送信しました。")
        this.popupinfo("パスワード再設定メールを送信しました。メールを確認してパスワードを再設定してください。")
      }).catch((error) => {
        console.log("パスワード再設定メール送信に失敗しました。", error)
        this.popupinfo("問題が発生しました。もう一度お試しください。")
      });
    }
  }

  // SNS連携の画面更新
  updateSns = (provider, user = null) => {
    let ref = null;  
    if (user && ["google", "twitter", "facebook"].indexOf(provider) !== -1) {
      ref = {mail: user.email, name: user.displayName, photo: user.photoURL, uid: user.uid};
    } else if (user) {
      ref = user;
    }
    if (provider === "google") this.setState({google: ref});
    if (provider === "twitter") this.setState({twitter: ref});
    if (provider === "facebook") this.setState({facebook: ref});
    if (provider === "instagram") this.setState({instagram: ref});
    if (provider === "tiktok") this.setState({tiktok: ref});
    if (provider === "youtube") this.setState({youtube: ref});
    if (provider === "note") this.setState({note: ref});
  }

  // 情報ポップアップの表示
  popupinfo = (text) => {
    this.setState({open: true, snackmessage: text});
  }

  // 情報ポップアップの非表示
  alertClose = (event, reason) => {
    if (reason === 'clickaway') {
      return;
    }
    this.setState({open: false});
  };

  render() {
    // console.log(this.state)
    return (
      <>
        <IconButton
          edge="end"
          className={"settngs-icon"}
          aria-label="account of current user"
          aria-haspopup="true"
          title="画像をアップロードしてプロフィールアイコンを変更します"
          component="label"
        >
          <Avatar alt={this.state.nowname} src={this.state.avatarUrl} style={{height:"96px", width:"96px"}} />
          <input
            type="file"
            onChange={this.changeAvatarUrl}
            style={{ display: "none" }}
            accept="image/png, image/jpeg"
          />
        </IconButton>
        <p style={{color: "#c79100", marginBottom: "20px"}}>プロフィール写真を編集する</p>
        <div className={"inputarea-center"}>
          <div className={"inputarea-center-div"}>
            <h3 className={"inputarea-center-label"} style={{fontWeight: "700", marginBottom: "5px"}}>マイプロフィール</h3>
            <div style={{width: "50vw"}}></div>
          </div>
          <Divider />
          <div className={"inputarea-center-div"}>
            <p className={"inputarea-center-label"}>名前</p>
            <TextField id="setting-input-displayname" className={"inputsettng"} style={{width: "50vw"}} value={this.state.name} onChange={this.changeName} />
          </div>
          <Divider />
          <div className={"inputarea-center-div"}>
            <p className={"inputarea-center-label"}>ディスプレイID</p>
            <div>
              <TextField id="setting-input-displayid" className={"inputsettng"} style={{width: "50vw"}} value={this.state.displayId} onChange={this.changeDisplayId} />
              <p style={{display: "flex", marginTop: "0"}}>
                {this.state.displayId.length >= 3 ?
                  this.state.ngDisplayId? "このIDはすでに使用されています" : "このIDを使用できます"
                :
                  <>IDは3文字以上の半角英数字または<br/>一部の記号( - _ )である必要があります</>
                }
              </p>
            </div>
          </div>
          <Divider />
          <div className={"inputarea-center-div"}>
            <p className={"inputarea-center-label"}>自己紹介</p>
            <TextField id="setting-input-displayintro" className={"inputsettng"} style={{width: "50vw"}} value={this.state.profiletext} multiline onChange={this.changeProfiletext} />
          </div>
          <Divider />
        </div>
        <div className={"inputarea-center"}>
          <div className={"inputarea-center-div"}>
            <h3 className={"inputarea-center-label"} style={{fontWeight: "700", marginBottom: "5px"}}>SNS連携</h3>
            <div style={{width: "50vw"}}></div>
          </div>
          <Divider />
          <SettingSns state={this.state.google} type={"google"} onChange={this.popupinfo} updateSns={this.updateSns}>
            <GoogleIcon className={"setting-loginicon"} />Google
          </SettingSns>
          <Divider />
          <SettingSns state={this.state.twitter} type={"twitter"} onChange={this.popupinfo} updateSns={this.updateSns}>
            <TwitterIcon className={"setting-loginicon"} />Twitter
          </SettingSns>
          <Divider />
          <SettingSns state={this.state.facebook} type={"facebook"} onChange={this.popupinfo} updateSns={this.updateSns}>
            <FacebookIcon className={"setting-loginicon"} />Facebook
          </SettingSns>
          <Divider />
          <SettingSns state={this.state.instagram} type={"instagram"} onChange={this.popupinfo} updateSns={this.updateSns}>
            <img className={"setting-loginicon"} style={{width: "20px", height: "20px"}} src={InstagramIcon} />Instagram
          </SettingSns>
          <Divider />
          <SettingSns state={this.state.tiktok} type={"tiktok"} onChange={this.popupinfo} updateSns={this.updateSns}>
            <TiktokIcon className={"setting-loginicon"} />TikTok
          </SettingSns>
          <Divider />
          <SettingSns state={this.state.youtube} type={"youtube"} onChange={this.popupinfo} updateSns={this.updateSns}>
            <YoutubeIcon className={"setting-loginicon"} />YouTube
          </SettingSns>
          <Divider />
          <SettingSns state={this.state.note} type={"note"} onChange={this.popupinfo} updateSns={this.updateSns}>
            <NoteIcon className={"setting-loginicon"} />note
          </SettingSns>
          <Divider />
        </div>
        <div className={"inputarea-center"}>
          <div className={"inputarea-center-div"}>
            <h3 className={"inputarea-center-label"} style={{fontWeight: "700", marginBottom: "5px"}}>アカウント設定</h3>
            <div style={{width: "50vw"}}></div>
          </div>
          <Divider />
          <div className={"inputarea-center-div"}>
            <p className={"inputarea-center-label"}>メールアドレス</p>
            <TextField id="setting-input-mail" className={"inputsettng"} style={{width: "50vw"}} value={this.state.mail} onChange={this.changeMail} />
          </div>
          <Divider />
          {this.state.nowmail !== ""?
            <>
              <div className={"inputarea-center-div"}>
                <p className={"inputarea-center-label"}>メールアドレス確認</p>
                {this.state.mailverified?
                  <p id="setting-input-mailverified" className={"textsettng"} style={{width: "50vw", margin: ".3em"}} >✅確認済み</p>
                :
                  <button id="setting-button-mailverified" className={"inputsettingbutton"} style={{width: "50vw"}} onClick={this.sendEmailVerification}>確認メールを再送信する</button>
                }
              </div>
              <Divider />
              <div className={"inputarea-center-div"}>
                <p className={"inputarea-center-label"}>パスワード</p>
                <button id="setting-button-password" className={"inputsettingbutton"} style={{width: "50vw"}} onClick={this.sendPassSetting} >パスワード再設定の<br/>メールを送信する</button>
              </div>
              <Divider />
            </>
          : null }
        </div>
        <div style={{height: "20px"}} />
        <SaveBtn
          handleSave={this.updateProfile}
          enable={
            this.state.isChangedName * this.state.isChangedAvatar * this.state.isChangedDid * this.state.isChangedProftext * this.state.isChangedMail === 0
            || this.state.isChangedName * this.state.isChangedAvatar * this.state.isChangedDid * this.state.isChangedProftext * this.state.isChangedMail === 32?
            false: true
          }
        />
        <Button
          component={Link}
          to={this.state.redirect === "/" ? this.state.intro?
              "/?intro=1"
            : "/"
          : this.state.intro? decodeURIComponent(this.state.redirect) + "&intro=1"
            : decodeURIComponent(this.state.redirect)
          }
          fullWidth
          variant="contained"
          color="secondary"
          className={"cancelSettingsBtn"}
        >
          {this.state.isSkippable? "スキップ" : "キャンセル"}
        </Button>
        <Snackbar
          anchorOrigin={{
            vertical: 'bottom',
            horizontal: 'center',
          }}
          open={this.state.open}
          autoHideDuration={4000}
          onClose={this.alertClose}
          message={this.state.snackmessage}
          action={
            <React.Fragment>
              <IconButton size="small" aria-label="close" color="inherit" onClick={this.alertClose}>
                <CloseIcon fontSize="small" />
              </IconButton>
            </React.Fragment>
          }
        >
        </Snackbar>
      </>
    )
  }
}